export default __webpack_public_path__ + "static/media/relocationPackage.c101ac4d.svg";